export default __webpack_public_path__ + "static/logo2-54ab716707f0e8aab06aa2f6035584d2.png";